import {post, postfile, downFile, downFileJson} from './http'
const baseUrl = '/api/admin/kmc/course'

// 课程分页
export const getAllCourseList = v => post(`${baseUrl}/getAllCourse`, v.data, v.success, v.error)
// 修改是否推荐
export const updateInnerRecomByCourse = v => post(`${baseUrl}/updateInnerRecomByCourse`, v.data, v.success, v.error)
// 获取推荐课程
export const getAllCourseByInnerRecom = v => post(`${baseUrl}/getAllCourseByInnerRecom`, v.data, v.success, v.error)
// 保存推荐课程排序
export const updateInnerRecomSortInfo  = v => post(`${baseUrl}/updateInnerRecomSortInfo `, v.data, v.success, v.error)

// 新增或编辑课程信息
export const saveOrUpdateCourseInfo = v => post(`${baseUrl}/saveOrUpdateCourseInfo`, v.data, v.success, v.error)

// 获取课程详情
export const getCourseInfo = v => post(`${baseUrl}/getCourseInfo`, v.data, v.success, v.error)

// 修改课程状态操作
export const updateCourseByStatus = v => post(`${baseUrl}/updateCourseByStatus`, v.data, v.success, v.error)

// 课程章节设置详情
export const getCourseSectionDetail = v => post(`${baseUrl}/getCourseSectionDetail`, v.data, v.success, v.error)
// 课程章节设置新增或编辑
export const saveOrUpdateCourseSection = v => post(`${baseUrl}/saveOrUpdateCourseSection`, v.data, v.success, v.error)

// 获取老师列表
export const getTeacherList = v => post(`${baseUrl}/getTeacherList`, v.data, v.success, v.error)
// 新增、编辑老师信息
export const saveOrUpdateTeacher = v => post(`${baseUrl}/saveOrUpdateTeacher`, v.data, v.success, v.error)
// 删除老师信息
export const updateTeacherStatus = v => post(`${baseUrl}/updateTeacherStatus`, v.data, v.success, v.error)
// 获取课程分类信息
export const getCatelist = v => post(`${baseUrl}/getCatelist`, v.data, v.success, v.error)
// 获取老师列表（不分页）
export const getTeacherListNopage = v => post(`${baseUrl}/getTeacherListNopage`, v.data, v.success, v.error)
// 获取老师评价列表
export const getAllCommentPage = v => post(`${baseUrl}/getAllCommentPage`, v.data, v.success, v.error)
// 评价列表状态修改
export const updateCommentStatus = v => post(`${baseUrl}/updateCommentStatus`, v.data, v.success, v.error)
// 获取讨论列表
export const getAllDiscussPage = v => post(`${baseUrl}/getAllDiscussPage`, v.data, v.success, v.error)
// 屏蔽/恢复讨论
export const updateDiscussStatus = v => post(`${baseUrl}/updateDiscussStatus`, v.data, v.success, v.error)
// 获取笔记列表
export const getAllNotesPage = v => post(`${baseUrl}/getAllNotesPage`, v.data, v.success, v.error)
// 屏蔽/恢复笔记
export const updateNotesStatus = v => post(`${baseUrl}/updateNotesStatus`, v.data, v.success, v.error)
// 获取机构详情
export const getHostDetail = v => post(`${baseUrl}/getHostDetail`, v.data, v.success, v.error)
// 机构编辑
export const updateHostinfo = v => post(`${baseUrl}/updateHostinfo`, v.data, v.success, v.error)
// 获取课程资料列表：
export const getCourseDocList = v => post(`${baseUrl}/getCourseDocList`, v.data, v.success, v.error)
// 删除课程资料：
export const deleteCourseDoc = v => post(`${baseUrl}/deleteCourseDoc`, v.data, v.success, v.error)
// 提交课程资料信息
export const saveCourseDocInfo = v => post(`${baseUrl}/saveCourseDocInfo`, v.data, v.success, v.error)
// 数据分析-人员列表
export const getCoursestudyinfoByCustomer = v => post(`${baseUrl}/getCoursestudyinfoByCustomer`, v.data, v.success, v.error)
// 数据分析-人员导出
export const getExportCoursestudyinfo = v => downFile(`${baseUrl}/getExportCoursestudyinfo`, v.data, v.success, v.error)
// 数据分析-订单列表
export const getCourseInfoOrderList = v => post(`${baseUrl}/getCourseInfoOrderList`, v.data, v.success, v.error)
// 数据分析-订单列表导出
export const getExportCoursestudyinfoByOrder = v => downFile(`${baseUrl}/getExportCoursestudyinfoByOrder`, v.data, v.success, v.error)
// 学习趋势图
export const getLearningTrendChart = v => post(`${baseUrl}/getLearningTrendChart`, v.data, v.success, v.error)
// 完课率趋势图
export const getFinishRateChart = v => post(`${baseUrl}/getFinishRateChart`, v.data, v.success, v.error)
// 交易效果图
export const getTradingSituation = v => post(`${baseUrl}/getTradingSituation`, v.data, v.success, v.error)
// 表单数据列表
export const getCourseUserFormlist = v => post(`${baseUrl}/getCourseUserFormlist`, v.data, v.success, v.error)
// 导出
export const exportFormInfo = v => downFile(`${baseUrl}/exportFormInfo`, v.data, v.success, v.error)
